<template>
  <Modal
    name="DELETE_SPECIALTY_MODAL"
    :title="$t('host.label.deleteSpecialties')"
    actions
  >
    <template v-slot:body>
      <div class="mw-600 mx-auto">
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">
                {{ $t('host.label.specialties') }}
              </th>
              <th class="text-right">
                {{ $t('host.label.actions') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in specialties" :key="item.id">
              <td>{{ item.name }}</td>
              <td class="text-right">
                <v-btn
                  icon
                  @click="openDeleteModal(item)"
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>

            <tr v-if="!specialties || specialties.length === 0">
              <td colspan="2" class="text-center grey--text">
                {{ $t('host.label.noSpecialties') }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>

      <DeleteModal
        ref="deleteModal"
        to-delete="deleteSpecialty"
        :callback="afterDelete"
      />
    </template>

    <template v-slot:actions>
      <v-btn
        @click="closeModal"
        :disabled="isLoading"
        elevation="0"
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import DeleteModal from '@/components/app/DeleteModal'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HostDeleteSpecialtyModal',

  components: {
    Modal,
    DeleteModal,
  },

  computed: {
    ...mapGetters(['specialties', 'isLoading']),
  },

  methods: {
    ...mapActions([
      'fetchSpecialties',
      'showSuccessMessage',
      'showErrorMessage',
    ]),
    ...mapMutations(['closeAllModals']),

    closeModal() {
      this.closeAllModals()
    },

    openDeleteModal(item) {
      if (!item || !item.id) return
      this.$refs.deleteModal.openModal(item.id, item.name)
    },

    async afterDelete() {
      try {
        await this.fetchSpecialties({ search: '' })
        this.showSuccessMessage(this.$t('host.message.specialtyDeleted'))
      } catch (error) {
        const message =
          error?.data?.message ||
          this.$t('host.message.specialtyDeleteError')
        this.showErrorMessage(message)
      }
    },
  },
}
</script>
